/*
* 报价产品管理组件
*/

import React, { useState, useEffect, useMemo } from 'react';
import $ from 'jquery';
import CNF from '../../incs/Config.js';
import { Table, Input, Button, Flex, Space } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import {
    UjoinParams,
    AddRequestHeaders,
    winHeight,
    winWidth,
} from '../../incs/FunHelper.js';

const Lists = (props) => {
    const { dataLists, addProduct } = props
    const columns = useMemo(() => [
        {
            title: '', key: 'key', fixed: 'left', width: 50,
            render: function (record) {
                return <Button
                    color='primary'
                    variant='link'
                    style={{ padding: 0, height: 20 }}
                    icon={<PlusOutlined />}
                    onClick={() => {
                        addProduct(record);
                    }}></Button>
            }
        },
        { title: '产品编码', dataIndex: 'number', key: 'number', fixed: 'left', width: 140, },
        { title: '产品名称', dataIndex: 'name', key: 'name', ellipsis: true, width: 300, },
        { title: '规格型号', dataIndex: 'model', key: 'model', ellipsis: true, width: 325, },
        { title: '供应商编码', dataIndex: 'supplier_number', key: 'supplier_number', width: 100, },
        { title: '品牌', dataIndex: 'brand', key: 'brand', ellipsis: true, width: 130, },
        { title: '单位', dataIndex: 'unit', key: 'unit', ellipsis: true, width: 80, },
        { title: '描述', dataIndex: 'description', key: 'description', ellipsis: true, width: 450, },
        { title: '单价(元)', dataIndex: 'price', key: 'price', fixed: 'right', width: 150, },
    ], [addProduct]);

    return (
        <div style={{ width: winWidth > 200 ? winWidth - 245 : winWidth - 45, height: ((winHeight - 364) / 2 - 80) }}>
            <Table
                columns={columns}
                style={{ width: '100%' }}
                size='small'
                dataSource={dataLists}
                // virtual
                scroll={{
                    x: winWidth > 200 ? winWidth - 245 : winWidth - 45,
                    y: (winHeight - 364) / 2 - 85,
                }}
                bordered={true}
                pagination={false}
            />
        </div>
    );
}

const ProductTable = (props) => {
    const { btnLists, addProduct } = props;

    const [dataLists, setDataLists] = useState([]);

    const [name, setName] = useState('');
    const [number, setNumber] = useState('');


    useEffect(() => {
        let params = {
            status: CNF.status[0].value,
            page_size: CNF.pageSize * 10,
            current_index: 1,
            name,
            number,
        };

        // 注意：如果 0 也是有效值，需要额外处理，但此处页码和数量通常不为0或空
        params = Object.fromEntries(
            Object.entries(params).filter(([_, value]) => value !== '' && value !== null && value !== undefined)
        );

        $.ajax({
            url: `${CNF.scmsApi}products${UjoinParams(params)}`,
            headers: AddRequestHeaders(),
            type: 'GET',
        }).done((data) => {
            if (data.res === 0) {
                setDataLists(data.dat || []);
            } else {
                setDataLists([]);
            }
        })
    }, [name, number]);


    return (
        <div style={{ width: '100%', height: (winHeight - 364) / 2 }}>
            <Flex vertical gap='small'>
                <Space size='small'>
                    <Input
                        placeholder='产品编码'
                        value={number}
                        onChange={(e) => setNumber(e.target.value)}
                    />
                    <Input
                        placeholder='产品名称'
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                    />
                </Space>
                <Lists
                    btnLists={btnLists}
                    dataLists={dataLists}
                    addProduct={addProduct}
                />
            </Flex>
        </div>
    );
}

export default ProductTable